import gql from 'graphql-tag';
import {UCUMUnit} from "../../../helper/UCUMUnit";

export const getVitalSigns = gql`query getVitalSigns(
    $patientId: String!,
    $version: String!,
    $LDLUnit: String!
  ) {
    myHealthParameters(
      functions: { function: patientId, parameters: [$patientId] }
      conditions: {
        gate: and
        inputs: [
          { field: version, value: $version }
          {
            field: code
            operator: in
            parameters: ["8867-4", "29463-7", "85354-9", "18262-6", "69405-9"]
          }
        ]
      }
    ) {
      edges {
        node {
          code {
            coding {
              code
            }
          }
          valueQuantity(
            conversion: [
              { fromMetric: "29463-7", toUnit: "${ UCUMUnit.KILOGRAM.unit }" }
              { fromMetric: "8867-4", toUnit: "${ UCUMUnit.BPM.unit }" }
              { fromMetric: "18262-6", toUnit: "${ UCUMUnit.MILLIGRAM_PER_DECILITER.unit }" }
            ]
          ) {
            code
            value
          }
          valueQuantityPreferredUnit : valueQuantity(
            conversion: [
              { fromMetric: "18262-6", toUnit: $LDLUnit }
            ]
          ) {
            code
            value
          }
          component {
            valueQuantity(
              conversion: [
                { fromMetric: "8480-6", toUnit: "${ UCUMUnit.MILLIMETER_OF_MERCURY.unit }" }
                { fromMetric: "8462-4", toUnit: "${ UCUMUnit.MILLIMETER_OF_MERCURY.unit }" }
              ]
            ) {
              code
              value
            }
            code {
              coding {
                code
              }
            }
          }
        }
      }
    }
  }`;

export const getWalkingTest = gql`query getWalkingTest(
    $patientId: String!,
    $version: String!,
  ) {
    mySixMinuteWalkingTests(
      functions: [{ function: patientId, parameters: [$patientId] }]
      conditions: { field: version, value: $version }
    ) {
      distanceWalked
      notPerformedReason
      perceivedExertion
    }
  }`;

export const getEncounterMyDSSInfo = gql`query getEncounterMyDSSInfo(
    $patientId: Int!,
    $age: Int,
    $includeExtraSystolicDayValues: [Float!],
    $includeExtraDiastolicDayValues: [Float!]
  ) {
         myDSSInfo(patientId : $patientId){
            currentAmountReceivedHypertensionDrugs
            meanBloodPressureAboveGoal(
                includeExtraDiastolicDayValues : $includeExtraDiastolicDayValues, 
                includeExtraSystolicDayValues : $includeExtraSystolicDayValues, 
                age : $age
            )
          }
  }`;

export const getQuestionnaire = gql`query getQuestionnaire(
    $patientId: String!,
    $version: String!,
    $key: String!,
  ) {
    myQuestionnaireForms(
      functions: [{ function: patientId, parameters: [$patientId] }]
      conditions: {
        gate: and
        inputs: [
          { field: key, value: $key }
          { field: version, value: $version }
        ]
      }
      limit: 1
    ) {
      questionnaire {
        key
      }
      entries {
        question {
          key
        }
        givenAnswers {
          key
          openAnswer
          openAnswerObject
        }
      }
    }
  }`;

export const submitVitalSigns = gql`mutation submitVitalSigns(
    $patientId: Int!,
    $version: Int!,
    $systolic: Int!,
    $diastolic: Int!,
    $weight: Float!,
    $pulseRate: Float!,
  ) {
    createUpdateMyHealthParameters(
      patientId: $patientId,
      bloodPressure: [
        {
          unit: "${ UCUMUnit.MILLIMETER_OF_MERCURY.unit }",
          systolic: $systolic,
          diastolic: $diastolic,
          version: $version
        }
      ],
      weight: [
        { unit: "${ UCUMUnit.KILOGRAM.unit }", value: $weight, version: $version }
      ],
      pulseRate: [
        { unit: "${ UCUMUnit.BPM.unit }", value: $pulseRate, version: $version }
      ]) {
      code {
        coding {
          code
        }
      }
    }
  }`;

export const submitVitalSignsV6 = gql`mutation submitVitalSignsV6(
    $patientId: Int!,
    $version: Int!,
    $systolic: Int!,
    $diastolic: Int!,
    $weight: Float!,
    $pulseRate: Float!,
    $LDL: Float!,
    $LDLUnit: String!,
    $eGFR: Float!,
  ) {
    createUpdateMyHealthParameters(
      patientId: $patientId,
       bloodPressure: [
        {
          unit: "${ UCUMUnit.MILLIMETER_OF_MERCURY.unit }",
          systolic: $systolic,
          diastolic: $diastolic,
          version: $version
        }
      ],
      weight: [
        { unit: "${ UCUMUnit.KILOGRAM.unit }", value: $weight, version: $version }
      ],
      pulseRate: [
        { unit: "${ UCUMUnit.BPM.unit }", value: $pulseRate, version: $version }
      ],
      LDL: [
        { unit: $LDLUnit, value: $LDL, version: $version }
      ],
      eGFR: [
        { value: $eGFR, version: $version }
      ]) {
      code {
        coding {
          code
        }
      }
    }
}`;


export const submitWalkingTest = gql`mutation submitWalkingTest(
    $patientId: Int!,
    $version: Int!,
    $notPerformedReason: String,
    $distanceWalked: Int,
    $perceivedExertion: Float,
  ) {
    createUpdateMy6MWT(
      version: $version,
      patientId: $patientId,
      notPerformedReason: $notPerformedReason,
      distanceWalked: $distanceWalked,
      perceivedExertion: $perceivedExertion,
      type: "trial"
    ){
      id
    }
  }`;

export const submitQestionnaire = gql`mutation submitClinicalAssessment(
    $patientId: Int!,
    $version: Int!,
    $data: JSON!,
    $key: String!,
  ) {
    fillInQuestionnaire(
      questionnaireKey: $key,
      patientId: $patientId,
      version: $version,
      data: $data,
      useAnswerKeysInsteadOfIds: true,
    ) {
      id
    }
  }`;
